import qs from "qs";
import { useLocation } from "react-router-dom";
import useNavigate from "src/hooks/usePartnerNavigate";
import usePathSegment from "src/hooks/usePathSegment";
import { PagePath } from "src/pages/product/details";
import { useModal } from "src/recoil/modalState/hook";
import { isMobilePath } from "src/utils";
import { BaseButton } from "./BaseButton";

// typeof BaseButton
interface Props extends Omit<React.ComponentProps<typeof BaseButton>, "title"> {
  title?: string;
}

function GoToListButton({ title = "목록으로", className }: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setBaseModal } = useModal();

  const menu = usePathSegment();

  const to = isMobilePath(location.pathname) ? PagePath.mobileBase + "/" + menu : PagePath.base + "/" + menu;
  const goNavigate = () => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true, allowDots: true });
    // const queryParams = qsParse(location.search);

    const listParse = queryParams.list && qs.parse(String(queryParams?.list) as any, { allowDots: true });
    const newTo = listParse ? `${to}?${decodeURIComponent(qs.stringify(listParse, { allowDots: true }))}` : to;
    navigate(newTo);
  };

  return (
    <BaseButton
      title={title} //
      onClick={() => {
        if (location.pathname.includes("form")) {
          setBaseModal({
            isOpen: true,
            title: "현재 페이지에서 나가시겠습니까?",
            children: (
              <span>
                입력 중인 내용이 있는 경우,
                <br /> 저장을 하지 않은 정보는 사라집니다.
              </span>
            ),
            btnLeftTitle: "머무르기",
            btnRightTitle: "나가기",
            onClick: () => {
              goNavigate();
              setBaseModal({ isOpen: false });
            },
            onClose: () => {
              setBaseModal({ isOpen: false });
            },
          });
        } else {
          goNavigate();
        }
      }}
      className={`color-white size-large ${className}`}
    />
  );
}

export default GoToListButton;
